import { http } from 'connex-cds';

export default {
  createQuery: ({ entityRef, queryName, payload }) => {
    const path = `/${entityRef}/queries/${queryName}`;
    return http.post({ apiName: 'dashboards-exp', path: path, data: payload });
  },
};
